import { App } from '@app/shared/types/generated-v2';

export const conditionOptions = {
  EQUALS: [
    App.Enums.ReturnConditionType.AUTO_COMPLETE,
    App.Enums.ReturnConditionType.COUNTRY_SELECT,
    App.Enums.ReturnConditionType.CURRENCY_SELECT,
    App.Enums.ReturnConditionType.DATE_TIME,
    App.Enums.ReturnConditionType.DIMENSION,
    App.Enums.ReturnConditionType.META_DATA,
    App.Enums.ReturnConditionType.NUMBER,
    App.Enums.ReturnConditionType.PRICE,
    App.Enums.ReturnConditionType.QUESTION,
    App.Enums.ReturnConditionType.REQUEST_STATUS,
    App.Enums.ReturnConditionType.RESOLUTION_TYPE,
    App.Enums.ReturnConditionType.RETURN_ADDRESS_SELECT,
    App.Enums.ReturnConditionType.RETURN_ORDER_STATE,
    App.Enums.ReturnConditionType.RETURN_REASON,
    App.Enums.ReturnConditionType.RETURN_STATUS,
    App.Enums.ReturnConditionType.TEXT,
    App.Enums.ReturnConditionType.WEIGHT,
  ],
  GREATER_THAN: [
    App.Enums.ReturnConditionType.DATE_TIME,
    App.Enums.ReturnConditionType.DIMENSION,
    App.Enums.ReturnConditionType.META_DATA,
    App.Enums.ReturnConditionType.NUMBER,
    App.Enums.ReturnConditionType.PRICE,
    App.Enums.ReturnConditionType.WEIGHT,
  ],
  GREATER_THAN_EQUAL: [
    App.Enums.ReturnConditionType.DATE_TIME,
    App.Enums.ReturnConditionType.DIMENSION,
    App.Enums.ReturnConditionType.META_DATA,
    App.Enums.ReturnConditionType.NUMBER,
    App.Enums.ReturnConditionType.PRICE,
    App.Enums.ReturnConditionType.WEIGHT,
  ],
  INCLUDES: [
    App.Enums.ReturnConditionType.AUTO_COMPLETE,
    App.Enums.ReturnConditionType.META_DATA,
    App.Enums.ReturnConditionType.TAGS,
    App.Enums.ReturnConditionType.TEXT,
  ],
  LESS_THAN: [
    App.Enums.ReturnConditionType.DATE_TIME,
    App.Enums.ReturnConditionType.DIMENSION,
    App.Enums.ReturnConditionType.META_DATA,
    App.Enums.ReturnConditionType.NUMBER,
    App.Enums.ReturnConditionType.PRICE,
    App.Enums.ReturnConditionType.WEIGHT,
  ],
  LESS_THAN_EQUAL: [
    App.Enums.ReturnConditionType.DATE_TIME,
    App.Enums.ReturnConditionType.DIMENSION,
    App.Enums.ReturnConditionType.META_DATA,
    App.Enums.ReturnConditionType.NUMBER,
    App.Enums.ReturnConditionType.PRICE,
    App.Enums.ReturnConditionType.WEIGHT,
  ],
  NOT_EQUALS: [
    App.Enums.ReturnConditionType.AUTO_COMPLETE,
    App.Enums.ReturnConditionType.COUNTRY_SELECT,
    App.Enums.ReturnConditionType.CURRENCY_SELECT,
    App.Enums.ReturnConditionType.DATE_TIME,
    App.Enums.ReturnConditionType.DIMENSION,
    App.Enums.ReturnConditionType.META_DATA,
    App.Enums.ReturnConditionType.NUMBER,
    App.Enums.ReturnConditionType.PRICE,
    App.Enums.ReturnConditionType.QUESTION,
    App.Enums.ReturnConditionType.RESOLUTION_TYPE,
    App.Enums.ReturnConditionType.REQUEST_STATUS,
    App.Enums.ReturnConditionType.RETURN_ADDRESS_SELECT,
    App.Enums.ReturnConditionType.RETURN_ORDER_STATE,
    App.Enums.ReturnConditionType.RETURN_REASON,
    App.Enums.ReturnConditionType.RETURN_STATUS,
    App.Enums.ReturnConditionType.TEXT,
    App.Enums.ReturnConditionType.WEIGHT,
  ],
  NOT_INCLUDES: [
    App.Enums.ReturnConditionType.AUTO_COMPLETE,
    App.Enums.ReturnConditionType.META_DATA,
    App.Enums.ReturnConditionType.TAGS,
    App.Enums.ReturnConditionType.TEXT,
  ],
  STARTS_WITH: [
    App.Enums.ReturnConditionType.AUTO_COMPLETE,
    App.Enums.ReturnConditionType.META_DATA,
    App.Enums.ReturnConditionType.TEXT,
  ],
  ENDS_WITH: [
    App.Enums.ReturnConditionType.AUTO_COMPLETE,
    App.Enums.ReturnConditionType.META_DATA,
    App.Enums.ReturnConditionType.TEXT,
  ],
};

export const switchButtonOptions = [
  {
    label: 'And',
    value: 'AND',
  },
  {
    label: 'Or',
    value: 'OR',
  },
];
